module.exports = __webpack_public_path__ + "img/Morbida_island_raw.c658e84a.png";